import React from 'react';
import { getAddonsByTypeApi, getVideoApi } from '../api';
import RequestProvider from '../../RequestProvider';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import AddonsProviderComponent from '../components/AddonsProvider';

function AddonsProvider(props) {
  return (
    <RequestProvider
      requests={{
        getAddonsByType: getAddonsByTypeApi(),
        getVideo: getVideoApi()
      }}>

      {(requests) =>
      <AuthorisationConsumer>
          {
        ({ selectedOrganisation }) =>
        <AddonsProviderComponent
          billingEntityCode={selectedOrganisation?.billingEntityCode ?? null}
          includedAddons={selectedOrganisation?.includedAddonTypes ?? []}
          customAddonCosts={selectedOrganisation?.customAddonCosts ?? []}
          {...requests}
          {...props} />}



        </AuthorisationConsumer>}

    </RequestProvider>);

}

export default AddonsProvider;